import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginLayout    from './components/login/LoginLayout';
import ProtectedRoute from './auth/ProtectedRoute';

import AdminLayout      from './pages/admin/AdminLayout';
import AdminDashboard   from './pages/admin/AdminDashboard';
import CourseList       from './pages/admin/courses/CourseList';
import CourseDetail     from './pages/admin/courses/CourseDetail';
import InstructorList   from './pages/admin/instructors/InstructorList';
import InstructorDetail from './pages/admin/instructors/InstructorDetail';
import StudentList      from './pages/admin/students/StudentList';
import StudentDetail    from './pages/admin/students/StudentDetail';
import CertificateList  from './pages/admin/certificates/CertificateList';
import AdminSettings       from './pages/admin/AdminSettings';
import AdminModuleEditor   from './pages/admin/courses/AdminModuleEditor';

import InstructorLayout         from './pages/instructor/InstructorLayout';
import InstructorDashboard      from './pages/instructor/InstructorDashboard';
import InstructorCourse         from './pages/instructor/InstructorCourse';
import InstructorModuleEditor   from './pages/instructor/InstructorModuleEditor';
import InstructorStudents       from './pages/instructor/InstructorStudents';
import InstructorStudentDetail  from './pages/instructor/InstructorStudentDetail';
import InstructorAssignmentSubs from './pages/instructor/InstructorAssignmentSubs';

import StudentLayout    from './pages/student/StudentLayout';
import StudentDashboard from './pages/student/StudentDashboard';
import StudentCourse    from './pages/student/StudentCourse';
import StudentModule    from './pages/student/StudentModule';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── Login ── */}
        <Route path="/" element={<LoginLayout />} />

        {/* ── Admin portal ── */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard"        element={<AdminDashboard />} />
          <Route path="courses"          element={<CourseList />} />
          <Route path="courses/:id"                         element={<CourseDetail />} />
          <Route path="courses/:id/modules/:moduleId"     element={<AdminModuleEditor />} />
          <Route path="instructors"      element={<InstructorList />} />
          <Route path="instructors/:id"  element={<InstructorDetail />} />
          <Route path="students"         element={<StudentList />} />
          <Route path="students/:id"     element={<StudentDetail />} />
          <Route path="certificates"     element={<CertificateList />} />
          <Route path="settings"         element={<AdminSettings />} />
        </Route>

        {/* ── Instructor portal ── */}
        <Route
          path="/instructor"
          element={
            <ProtectedRoute requiredRole="instructor">
              <InstructorLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/instructor/dashboard" replace />} />
          <Route path="dashboard" element={<InstructorDashboard />} />
          <Route path="courses/:courseId" element={<InstructorCourse />} />
          <Route path="courses/:courseId/modules/:moduleId" element={<InstructorModuleEditor />} />
          <Route path="courses/:courseId/students" element={<InstructorStudents />} />
          <Route path="courses/:courseId/students/:studentId" element={<InstructorStudentDetail />} />
          <Route path="courses/:courseId/assignments/:assignmentId/submissions" element={<InstructorAssignmentSubs />} />
        </Route>

        {/* ── Student portal ── */}
        <Route
          path="/student"
          element={
            <ProtectedRoute requiredRole="student">
              <StudentLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/student/dashboard" replace />} />
          <Route path="dashboard"                               element={<StudentDashboard />} />
          <Route path="courses/:courseId"                       element={<StudentCourse />} />
          <Route path="courses/:courseId/modules/:moduleId"     element={<StudentModule />} />
        </Route>

        {/* ── Catch-all ── */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}
